import jQuery from 'jquery';

export default class MatrixPopover {
    constructor() {
        this.$matrixPopover = jQuery('.js-matrixPopOver');
        this.$matrixPopoverWrapper = jQuery('.js-RC-matrixPopOver__wrapper');
        this.$timeLine = jQuery('.js-RC-courseTime');
        this.leftPositionClass = 'RC-matrixPopOver__wrapper_leftSide';
        this.popoverActiveClass = 'RC-matrixPopOver_active';
        this.bindEvents();
    }

    bindEvents() {
        jQuery(document).on('popoverOpenedMatrix', this.setPopoverPosition.bind(this));
        jQuery(document).on('popoverClosedMatrix', this.resetPopoverPosition.bind(this));
        jQuery(window).on('rpBreakpointsSwitch', this.onBreakpointChange.bind(this));
    }

    setPopoverPosition() {
        if (this.$timeLine.offset().left > this.$matrixPopoverWrapper.offset().left) {
            this.$matrixPopoverWrapper.addClass(this.leftPositionClass);
        }
    }

    resetPopoverPosition() {
        this.$matrixPopoverWrapper.removeClass(this.leftPositionClass);
    }

    isActivePopover() {
        return this.$matrixPopover.hasClass(this.popoverActiveClass);
    }

    onBreakpointChange() {
        if (this.isActivePopover()) {
            this.resetPopoverPosition();
            this.setPopoverPosition();
        }
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/matrixPopOver/matrixPopover.js